import React from "react";
import { Box } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { ParallaxLayer } from 'react-spring/renderprops-addons';
import { useSpring, animated } from 'react-spring';

const calc = (x, y) => [x - window.innerWidth / 2, y - window.innerHeight / 2]
const skills = [
    { 
        name: 'Javascript', offset: 1.4, speed: .1, width: '30%', marginLeft: '20%', 
        weight: 'fontWeightBold', size: 80, rotate: '0deg', color: '#707070',
        transform: (x, y) => `translate3d(${x / 10}px,${y / 10}px,0)`
    },
    { 
        name: 'Typescript', offset: 1.3, speed: -.1, width: '30%', marginLeft: '45%', 
        weight: 'fontWeightBold', size: 90, rotate: '0deg', color: '#f9a825',
        transform: (x, y) => `translate3d(${x / 12}px,${y / 12}px,0)`
    },
    { 
        name: 'Bitbucket', offset: 1.68, speed: .2, width: '30%', marginLeft: '50.5%', 
        weight: 'fontWeightLight', size: 60, rotate: '90deg', color: '#0747A6',
        transform: (x, y) => `translate3d(${x / 9}px,${y / 9}px,0)`
    },
    { 
        name: 'Git', offset: 1.485, speed: -.2, width: '20%', marginLeft: '53.5%', 
        weight: 'fontWeightRegular', size: 65, rotate: '0deg', color: '#EB4D28',
        transform: (x, y) => `translate3d(${x / 8}px,${y / 8}px,0)`
    },
    { 
        name: 'Github', offset: 1.435, speed: .3, width: '20%', marginLeft: '53.5%', 
        weight: 'fontWeightRegular', size: 43, rotate: '0deg', color: '#707070',
        transform: (x, y) => `translate3d(${x / 18}px,${y / 18}px,0)`
    },
    { 
        name: 'GitLab', offset: 1.75, speed: -.25, width: '30%', marginLeft: '46.5%', 
        weight: 'fontWeightRegular', size: 50, rotate: '90deg', color: '#E65328',
        transform: (x, y) => `translate3d(${x / 13}px,${y / 13}px,0)`
    },
    { 
        name: 'PHP', offset: 1.35, speed: .2, width: '10%', marginLeft: '37.5%', 
        weight: 'fontWeightRegular', size: 50, rotate: '0deg', color: '#7377AD',
        transform: (x, y) => `translate3d(${x / 8 + 13}px,${y / 15}px,0)`
    },
    { 
        name: 'CodeIgniter', offset: 1.13, speed: -.15, width: '30%', marginLeft: '20%', 
        weight: 'fontWeightMedium', size: 40, rotate: '-90deg', color: '#DD4814',
        transform: (x, y) => `translate3d(${x / 14}px,${y / 8 + 14}px,0)`
    },
    { 
        name: 'Docker', offset: 1.47, speed: .2, width: '10%', marginLeft: '46.5%', 
        weight: 'fontWeightRegular', size: 30, rotate: '0deg', color: '#2391E6',
        transform: (x, y) => `translate3d(${x / 15}px,${y / 8 + 15}px,0)`
    },
    { 
        name: 'Vagrant', offset: 1.52, speed: -.2, width: '10%', marginLeft: '42.5%', 
        weight: 'fontWeightRegular', size: 40, rotate: '0deg', color: '#278BC6',
        transform: (x, y) => `translate3d(${x / 7}px,${y / 7}px,0)`
    },
    { 
        name: 'Ext JS', offset: 1.52, speed: .15, width: '10%', marginLeft: '33%', 
        weight: 'fontWeightBold', size: 40, rotate: '0deg', color: '#95C93D',
        transform: (x, y) => `translate3d(${x / 16}px,${y / 16}px,0)`
    },
    { 
        name: 'Node.js', offset: 1.31, speed: -.15, width: '10%', marginLeft: '37%', 
        weight: 'fontWeightRegular', size: 30, rotate: '0deg', color: '#78B361',
        transform: (x, y) => `translate3d(${x / 17}px,${y / 17}px,0)`
    },
    { 
        name: 'Express', offset: 1.45, speed: .11, width: '20%', marginLeft: '67.5%', 
        weight: 'fontWeightRegular', size: 45, rotate: '0deg', color: '#707070',
        transform: (x, y) => `translate3d(${x / 9.5}px,${y / 9.5}px,0)`
    },
    { 
        name: 'React', offset: 1.36, speed: -.11, width: '20%', marginLeft: '22%', 
        weight: 'fontWeightLight', size: 60, rotate: '0deg', color: '#29b6f6',
        transform: (x, y) => `translate3d(${x / 10.5}px,${y / 10.5}px,0)`
    },
    { 
        name: 'Vue.js', offset: 1.38, speed: .13, width: '10%', marginLeft: '15.8%', 
        weight: 'fontWeightRegular', size: 30, rotate: '0deg', color: '#3FB27F',
        transform: (x, y) => `translate3d(${x / 11.5}px,${y / 11.5}px,0)`
    },
    { 
        name: 'Gatsby', offset: 1.30, speed: -.13, width: '10%', marginLeft: '59.2%', 
        weight: 'fontWeightLight', size: 40, rotate: '0deg', color: '#663399',
        transform: (x, y) => `translate3d(${x / 12.5}px,${y / 12.5}px,0)`
    },
    { 
        name: 'MySQL', offset: 1.28, speed: .16, width: '10%', marginLeft: '48.55%', 
        weight: 'fontWeightRegular', size: 45, rotate: '0deg', color: '#00758F',
        transform: (x, y) => `translate3d(${x / 13.5}px,${y / 13.5}px,0)`
    },
    { 
        name: 'PostgreSQL', offset: 1.443, speed: -.16, width: '10%', marginLeft: '72%', 
        weight: 'fontWeightRegular', size: 20, rotate: '0deg', color: '#326690',
        transform: (x, y) => `translate3d(${x / 14.5}px,${y / 14.5}px,0)`
    },
    { 
        name: 'MongoDB', offset: 1.4, speed: .17, width: '10%', marginLeft: '76.7%', 
        weight: 'fontWeightMedium', size: 30, rotate: '0deg', color: '#13AA52',
        transform: (x, y) => `translate3d(${x / 15.5}px,${y / 15.5}px,0)`
    },
    { 
        name: 'Sequelize', offset: 1.56, speed: -.17, width: '15%', marginLeft: '11.9%', 
        weight: 'fontWeightLight', size: 30, rotate: '90deg', color: '#03AFEF',
        transform: (x, y) => `translate3d(${x / 9.3}px,${y / 9.3}px,0)`
    },
    { 
        name: 'Linux', offset: 1.65, speed: .18, width: '15%', marginLeft: '15%', 
        weight: 'fontWeightRegular', size: 40, rotate: '90deg', color: '#707070',
        transform: (x, y) => `translate3d(${x / 9.8}px,${y / 9.8}px,0)`
    },
    { 
        name: 'Salesforce', offset: 1.54, speed: -.18, width: '15%', marginLeft: '24.2%', 
        weight: 'fontWeightRegular', size: 25, rotate: '0deg', color: '#00A1E0',
        transform: (x, y) => `translate3d(${x / 10.3}px,${y / 10.3}px,0)`
    },
    { 
        name: 'Apex', offset: 1.52, speed: .12, width: '10%', marginLeft: '36.5%', 
        weight: 'fontWeightRegular', size: 25, rotate: '-90deg', color: '#2196f3',
        transform: (x, y) => `translate3d(${x / 10.8}px,${y / 10.8}px,0)`
    },
    { 
        name: 'Netsuite', offset: 1.155, speed: -.01, width: '15%', marginLeft: '39%', 
        weight: 'fontWeightLight', size: 48, rotate: '-90deg', color: '#707070',
        transform: (x, y) => `translate3d(${x / 11.3}px,${y / 11.3}px,0)`
    },
    { 
        name: 'SuiteScript', offset: 1.35, speed: .14, width: '15%', marginLeft: '24.5%', 
        weight: 'fontWeightMedium', size: 25, rotate: '0deg', color: '#707070',
        transform: (x, y) => `translate3d(${x / 11.8}px,${y / 11.8}px,0)`
    },
    { 
        name: 'Google Cloud Platform', offset: 1.27, speed: -.14, width: '30%', marginLeft: '59%', 
        weight: 'fontWeightMedium', size: 25, rotate: '0deg', color: '#E34133',
        transform: (x, y) => `translate3d(${x / 12.3}px,${y / 12.3}px,0)`
    },
    { 
        name: 'Firebase', offset: 1.13, speed: .19, width: '15%', marginLeft: '50.5%', 
        weight: 'fontWeightMedium', size: 25, rotate: '-90deg', color: '#f9a825',
        transform: (x, y) => `translate3d(${x / 12.8}px,${y / 12.8}px,0)`
    },
    { 
        name: 'Jenkins', offset: 1.6, speed: -.19, width: '15%', marginLeft: '11%', 
        weight: 'fontWeightRegular', size: 40, rotate: '0deg', color: '#D33833',
        transform: (x, y) => `translate3d(${x / 13.3}px,${y / 13.3}px,0)`
    },
    { 
        name: 'Firebird', offset: 1.7, speed: 1, width: '15%', marginLeft: '17%', 
        weight: 'fontWeightLight', size: 30, rotate: '90deg', color: '#F3773D',
        transform: (x, y) => `translate3d(${x / 13.8}px,${y / 13.8}px,0)`
    },
]


export default function Mastery() {
    const [props, set] = useSpring(() => ({ xy: [0, 0], config: { mass: 10, tension: 550, friction: 140 } }))
    const theme = useTheme()
    const contrastThemeType = props.darkMode ? 'light' : 'dark'

    return <div onMouseMove={({ clientX: x, clientY: y }) => set({ xy: calc(x, y) })} role="presentation">
        <ParallaxLayer 
            offset={1} speed={1} 
            style={{ 
                backgroundColor: theme.palette.secondary[contrastThemeType], 
                opacity: 0.2
            }} 
        />

        {skills.map((skill, index) => {
            return <ParallaxLayer offset={skill.offset} speed={skill.speed} key={`skill-${index}`}>
                <Box
                    key={`skill-box-${index}`}
                    fontWeight={skill.weight}
                    fontSize={skill.size}
                    style={{
                        width: skill.width,
                        marginLeft: skill.marginLeft,
                        transform: `rotate(${skill.rotate})`,
                        color: skill.color
                    }}
                >
                    <animated.div 
                        key={`skill-animate-div-${index}`}
                        style={{ 
                            transform: props.xy.interpolate(skill.transform),
                            willChange: 'transform' 
                        }} 
                    >
                        {skill.name}
                    </animated.div>
                </Box>
            </ParallaxLayer>
        })}
    </div>
}